import { mq, spacing, styled, Text } from '@thg-commerce/gravity-theme'

export const StepsContainer = styled.div<{
  progressWidth: string
  enableAlternateProgressBar?: boolean
  progressHeight?: string
  isRounded: boolean
}>`
  display: flex;
  justify-content: space-around;
  position: relative;
  width: 100%;
  margin: ${spacing(2)} 0;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin: ${spacing(4)} ${spacing(2)};
  }

  :before {
    content: '';
    position: absolute;
    background: ${(props) => props.theme.colors.palette.greys.grey};
    height: ${(props) => (props.progressHeight ? props.progressHeight : '2px')};
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    border-radius: ${(props) =>
      props.enableAlternateProgressBar && props.isRounded ? '12px' : '0'};
  }
  :after {
    content: '';
    position: absolute;
    height: ${(props) => (props.progressHeight ? props.progressHeight : '2px')};
    background: ${(props) => props.theme.colors.palette.brand.base};
    width: ${(props) => props.progressWidth};
    top: 50%;
    transition: 0.4s ease;
    transform: translateY(-50%);
    left: 0;
    border-radius: ${(props) =>
      props.enableAlternateProgressBar && props.isRounded ? '12px' : '0'};
  }
`

export const StepWrapper = styled.div`
  position: relative;
  z-index: 1;
`

export const StepStyle = styled.div<{
  isIncomplete: boolean
}>`
  ${Text('bodyText', 'alternate')}
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: 0.4s ease;
  outline: 2px solid ${(props) => props.theme.colors.palette.greys.white};
  color: ${(props) =>
    props.isIncomplete
      ? props.theme.colors.palette.greys.grey
      : props.theme.colors.palette.greys.lighter};

  background-color: ${(props) =>
    props.isIncomplete
      ? props.theme.colors.palette.greys.lighter
      : props.theme.colors.palette.brand.base};
  border: 2px solid
    ${(props) =>
      props.isIncomplete
        ? props.theme.colors.palette.greys.grey
        : props.theme.colors.palette.brand.base};
  svg {
    path {
      fill: ${(props) =>
        props.isIncomplete
          ? props.theme.colors.palette.greys.grey
          : props.theme.colors.palette.greys.lighter};
    }
  }
`

export const StepGoalLabel = styled.span<{
  position: 'start' | 'end'
  progressHeight?: string
}>`
  ${Text('bodyText', 'alternate')}
  position: absolute;
  bottom: calc(-${(props) => props.progressHeight} - ${spacing(3)});
  left: ${(props) => (props.position === 'start' ? '0' : 'unset')};
  right: ${(props) => (props.position === 'start' ? 'unset' : '0')};
`

export const StepLabel = styled.span<{
  isIncomplete: boolean
}>`
  ${Text('xsmall', 'alternate')}
  position: absolute;
  bottom: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  white-space: nowrap;
  
    color: ${(props) =>
      props.isIncomplete
        ? props.theme.colors.palette.greys.grey
        : props.theme.colors.palette.brand.base};
  }
`

export const StyledText = styled.span<{ progressHeight?: string }>`
  position: absolute;
  left: 0;
  top: calc(${(props) => props.progressHeight} * -2);
`
